import '../Footer.scss';

export const Copyright = (): JSX.Element => (
  <footer>
    <div className="container">
      <p className="copyright-text">Copyright © 2018. All rights reserved.</p>
    </div>
  </footer>
);
